// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3QU12","header":"ReportDetails_header__2E--D","title":"ReportDetails_title__3vE4F","left":"ReportDetails_left__1_XAz"};